import { Component } from "@angular/core";
import { IStore } from "@merchant_app/storage/store";
import { Store } from "@ngrx/store";
import * as WebhookActions from "@merchant_app/storage/webhook/webhook.actions";
import { getWebhooks, getWebhooksLoading, getWebhooksError } from "@merchant_app/storage/webhooks/webhooks.selectors";
import { getToggleWebhooksLoading } from "@merchant_app/storage/webhook/webhook.selectors";
import { WebhookDto } from "@merchant_api/models/webhook-dto";
import { UpdateWebhookDto } from "@merchant_api/models/update-webhook-dto";

@Component({
    selector: "app-webhooks",
    templateUrl: "./webhooks.component.html",
    styleUrls: ["./webhooks.component.less"],
    standalone: false
})
export class WebhooksComponent {

    webhooks$ = this.store.select(getWebhooks);
    loading$ = this.store.select(getWebhooksLoading);
    error$ = this.store.select(getWebhooksError);
    toggleWebhooksLoading$ = this.store.select(getToggleWebhooksLoading);

    constructor(private store: Store<IStore>) {}

    onIsActiveToggled(payload: {webhook: WebhookDto; undo: () => void}) {
        this.store.dispatch(new WebhookActions.ToggleWebhookAction(payload.webhook.id, payload.webhook, payload.undo));
    }

}
